module.exports = __webpack_public_path__ + "img/home-page-footer.62403d94.jpg";